// Styles copied from VizportalClient
import { TabStyles } from '@tableau/widgets';
import { elideTextStyle } from './LayoutStyles';
import { cssClass, Style } from './StyleFunctions';

// Copied from vizportalclient, ExplorerStyles.ts
export const ListViewRowOuterHeight = 44;

// From vizportalclient/src/app/spaces/SpacesStyles.ts

const headerIconSize = '60px';
const titleFontSize = '26px';
const titleRowHeight = '30px';

// from vizportalclient: src/styl/includes/colors.styl

export const AccessibleHyperLinkBlue = '#1a699e';
export const AccessibleHyperLinkBlueHover = '#2a79af';
export const AccessibleHyperLinkBlueFocus = '#15557f';

export const Grey218 = 'rgb(218,218,218)';

// From vizportalclient/src/app/spaces/Header/SpaceHeaderStyles.ts

export const headerPaddingStyle: Style = {
  paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
  paddingRight: TabStyles.Spacing.ExtraLargeSpace,
  paddingTop: TabStyles.Spacing.LargeSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace,
};

// From SpaceHeaderContent in vizportalclient/src/app/spaces/Explorer/ExplorerStyles.ts
export const spaceHeaderContentStyle: Style = {
  marginTop: TabStyles.Spacing.MediumSpace,
  marginBottom: TabStyles.Spacing.MediumSpace,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  height: 18
};

export const nonPlaceTitleStyle: Style = {
  color: TabStyles.Typography.Color.Primary,
  fontSize: TabStyles.Typography.Sizing.XXLarge,
};

export const headerIconContainerStyle: Style = {
  position: 'relative',
  minWidth: headerIconSize,
  height: headerIconSize,
  marginRight: TabStyles.Spacing.MediumSpace,
};

export const headerIconStyle: Style = {
  position: 'absolute',
  top: '-5px', // This vertically aligns it with the owner text
  left: 0,
  width: headerIconSize,
  height: headerIconSize,
};

export const MetadataLabelColor = {
  color: '#9B9B9B',
};

export const placeHeaderTitleStyle: Style = {
  ...elideTextStyle,
  color: TabStyles.Typography.Color.Primary,
  fontSize: titleFontSize,
  height: titleRowHeight,
  lineHeight: titleRowHeight,
  marginRight: TabStyles.Spacing.ExtraLargeSpace,
};

export const vizPortalFontStyle: Style = {
  fontFamily: 'Benton Sans, Arial, Helvetica, sans-serif',
  fontSize: TabStyles.Typography.Sizing.Default,
  lineHeight: '1.5em',
};

// We shouldn't be using the low-DPI font, but some designers have specified it, so we're using it in some places
// in order for the DC3 visuals to match the main VizPortal visuals :-(
export const vizPortalLowDpiFontStyle: Style = {
  ...vizPortalFontStyle,
  fontFamily: 'Benton Sans Low-DPI, Arial, Helvetica, sans-serif',
};

export const linkStyle: Style = {
  color: AccessibleHyperLinkBlue,
  textDecoration: 'none',
  outline: 0,
  cursor: 'pointer',
  $nest: {
    '&:hover': {
      textDecoration: 'underline',
      color: AccessibleHyperLinkBlueHover,
    },
    '&:focus': {
      textDecoration: 'underline',
      color: AccessibleHyperLinkBlueFocus,
    }
  }
};

export const placeHeaderMetadataLinkStyle: Style = {
  ...linkStyle,
  color: '#4996B2', // VizPortal place headers use a different link blue than other parts of the app
};

export const linkClass = cssClass('link', linkStyle);
export const placeHeaderMetadataLinkClass = cssClass('placeHeaderMetadataLink', placeHeaderMetadataLinkStyle);

export const vizPortalFontClass = cssClass('VizPortalFont', vizPortalFontStyle);

export const minWidthClass = cssClass('MinWidth', {
  minWidth: 0
});

export const actionsMenuStyle: Style = {
  height: titleRowHeight,
  lineHeight: titleRowHeight
};

export const certificationIconStyle = cssClass('certification-icon', {
  alignContent: 'center',
  display: 'flex',
  justifyContent: 'center',
  height: '16px',
  width: '16px',
  marginRight: TabStyles.Spacing.SmallSpace,
  marginLeft: TabStyles.Spacing.SmallSpace,
});

const separator: Style = {
  height: 1,
  backgroundColor: TabStyles.Colors.L9Disabled,
  marginBottom: TabStyles.Spacing.MediumSpace,
  marginTop: TabStyles.Spacing.MediumSpace,
};

export const separatorExpanded = cssClass('separator-expanded', {
  ...separator,
  marginRight: TabStyles.Spacing.SmallSpace,
  marginLeft: TabStyles.Spacing.SmallSpace,
});
